import { getAuthHeaders } from '../utils/authHeaders';

const API_URL = 'https://app.pvslimited.co.uk/api';

export async function fetchUltrasonicDailyCheckStatus() {
  const response = await fetch(`${API_URL}/ultrasonic-daily-check/status`, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || 'Failed to load ultrasonic daily check status.');
  }

  return response.json();
}

export default fetchUltrasonicDailyCheckStatus;
